<template>
  <div>

  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import axios from 'axios';
  export default {
    data() {
      return {
        sessionToken: '', // sessionStorage的token
        localToken: '',
        targetPath:'',
        loginName:''
      }
    },
    created() {
      window.addEventListener('message', (event) => {
        // console.log(event.data);
        // this.targetPath=event.data.path;
        // this.loginName=event.data.name;
        // localStorage.setItem('loginName', event.data.name);
        // localStorage.setItem('redirectPath', event.data.path);
        // localStorage.setItem('adminToken', event.data.adminToken);
        // this.localToken=event.data.adminToken;
        if(event.data.type=="inject-styles"){
          sessionStorage.setItem('data', event.data);
        }
      });
    },
    mounted() {
      // this.initTokens();
      // this.handleLogin();
    },
    watch: {
      targetPath(newVal) {
        console.log('targetPath变化:', newVal)
      },
      loginName(newVal){
        console.log('loginName变化:', newVal)
      }
    },
    methods: {
      ...mapMutations(['adduser']),
      initTokens() {
      try {
        const user = JSON.parse(decodeURIComponent(
          window.sessionStorage.getItem('user') || '{}'
        ));
        this.sessionToken = user.token?user.token:'';
      } catch (e) {
        this.sessionToken = '';
      }
      this.localToken = localStorage.getItem('adminToken') || '';
    },
      getTokenTest() {
        return new Promise((resolve, reject) => {
          this.$http(
            'api1',
            '/sys/user/test',
            'get'
          ).then(res => {
            // console.log(res);
            
            if(res&&res.data&&res.data.code==0){
              resolve(true);
            }else{
              resolve(false);
            }
            
          }).catch(err => {
            reject(err);
          });
        });
      },
      getTicket(token){
        return new Promise((resolve, reject) => {
          axios({
            url:'http://192.168.0.178:8081/sso/createTicket',
            method:"GET",
            headers: {
              'Authorization': token
            }
          }).then(res => {
            if(res&&res.data){
              resolve(res.data);
            }else{
              reject(false);
            }
            
          }).catch(err => {
            reject(err);
          });
        });
      },
      getTokenByLogin(ticket,name){
        return new Promise((resolve, reject) => {
          this.$http(
            'api1',
            '/sso/login',
            'get',
            {
              ticket,
              name
            }
          ).then(res => {
            resolve(res);
          }).catch(err => {
            reject(err);
          });
        });
      },
      async performLogin() {
      try {
        const ticket = await this.getTicket(this.localToken);
        const { data } = await this.getTokenByLogin(ticket,this.loginName);
        
        if (!data || data.code !== 0) {
          this.$message.error('登录凭证无效');
          return false;
        }

        this.adduser({
          token: data.token,
          username: this.loginName // 建议从接口获取真实用户名
        });
        
        this.$router.push(this.targetPath);
        localStorage.removeItem('redirectPath');
        return true;
      } catch (error) {
        console.error('登录流程异常:', error);
        this.$message.error('登录流程异常');
        return false;
      }
    },
    async handleLogin() {
      // 优先使用sessionToken
      
      if (this.sessionToken) {
        
        const testValid = await this.getTokenTest();
        if (!testValid) {
          await this.performLogin();
        } else {
          this.$router.push(this.targetPath);
          localStorage.removeItem('redirectPath');
        }
      } else {
        await this.performLogin();
      }
    },
    }
  }
</script>

<style lang="scss" scoped>

</style>